export default __webpack_public_path__ + "static/biegel-36342cc8b85494091b494fef2e2729f6.jpg";